import { useState } from "react";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/dash/Common";
import CrudManager from "@/components/dash/CrudManager";
import { useAuth } from "@/context/AuthContext";
import AttendanceDialog from "@/pages/admin/AttendanceDialog";
import SubmissionsDialog from "@/pages/admin/SubmissionsDialog";
import * as C from "@/pages/admin/config";

const ROLE_TABS = [["", "Semua"], ["siswa", "Siswa"], ["pengajar", "Pengajar"], ["admin", "Admin"]];

export function UsersPage() {
  const [role, setRole] = useState("");
  const toolbar = (
    <div className="flex gap-1">
      {ROLE_TABS.map(([v, l]) => (
        <button key={v} onClick={() => setRole(v)} className={`px-3 py-1.5 rounded-md text-xs font-semibold ${role === v ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`} data-testid={`users-filter-${v || "all"}`}>{l}</button>
      ))}
    </div>
  );
  return (
    <div data-testid="admin-users-page">
      <PageHeader eyebrow="Data Pengguna" title="Siswa, pengajar & akun" description="Kelola akun, role, paket aktif, dan masa berlaku siswa. Admin juga dapat mengatur ulang kata sandi di sini." />
      <CrudManager endpoint="/admin/users" fields={C.USER_FIELDS} columns={C.USER_COLUMNS} testid="users" entity="Pengguna" toolbar={toolbar} filterRows={role ? (r) => r.role === role : undefined} />
    </div>
  );
}

export function PackagesPage() {
  return (
    <div data-testid="admin-packages-page">
      <PageHeader eyebrow="Paket Belajar" title="Paket & harga" description="Paket yang aktif tampil di halaman Program dan formulir pendaftaran." />
      <CrudManager endpoint="/admin/packages" fields={C.PACKAGE_FIELDS} columns={C.PACKAGE_COLUMNS} testid="packages" entity="Paket" />
    </div>
  );
}

export function CoursesPage() {
  return (
    <div data-testid="admin-courses-page">
      <PageHeader eyebrow="Kurikulum" title="Kurikulum & mata pelajaran" description="Atur mata pelajaran, pengajar, dan paket mana yang boleh mengakses." />
      <CrudManager endpoint="/admin/courses" fields={C.COURSE_FIELDS} columns={C.COURSE_COLUMNS} testid="courses" entity="Kurikulum" />
    </div>
  );
}

export function MaterialsPage() {
  return (
    <div data-testid="admin-materials-page">
      <PageHeader eyebrow="Materi" title="Materi, video & modul PDF" description="Video via link YouTube, modul PDF diunggah ke penyimpanan." />
      <CrudManager endpoint="/admin/materials" fields={C.MATERIAL_FIELDS} columns={C.MATERIAL_COLUMNS} testid="materials" entity="Materi" />
    </div>
  );
}

export function QuestionsPage() {
  return (
    <div data-testid="admin-questions-page">
      <PageHeader eyebrow="Bank Soal" title="Bank soal pilihan ganda" description="Soal dapat dipakai ulang di berbagai ujian." />
      <CrudManager endpoint="/admin/questions" fields={C.QUESTION_FIELDS} columns={C.QUESTION_COLUMNS} testid="questions" entity="Soal" />
    </div>
  );
}

export function ExamsPage() {
  return (
    <div data-testid="admin-exams-page">
      <PageHeader eyebrow="Ujian" title="Paket ujian CBT" description="Susun ujian dari bank soal, atur durasi, dan akses paket." />
      <CrudManager endpoint="/admin/exams" fields={C.EXAM_FIELDS} columns={C.EXAM_COLUMNS} testid="exams" entity="Ujian" />
    </div>
  );
}

export function SchedulePage() {
  const [cls, setCls] = useState(null);
  return (
    <div data-testid="admin-schedule-page">
      <PageHeader eyebrow="Jadwal" title="Jadwal kelas & absensi" description="Buat jadwal kelas live (Zoom/Meet), tambahkan link rekaman, dan catat kehadiran." />
      <CrudManager endpoint="/admin/classes" fields={C.CLASS_FIELDS} columns={C.CLASS_COLUMNS} testid="classes" entity="Kelas"
        rowActions={(r) => <Button size="sm" variant="outline" className="mr-1" onClick={() => setCls(r)} data-testid={`attendance-open-${r.id}`}>Absensi</Button>} />
      {cls && <AttendanceDialog cls={cls} onClose={() => setCls(null)} />}
    </div>
  );
}

export function AnnouncementsPage() {
  return (
    <div data-testid="admin-announcements-page">
      <PageHeader eyebrow="Pengumuman" title="Pengumuman" description="Pengumuman tampil di dashboard semua siswa." />
      <CrudManager endpoint="/admin/announcements" fields={C.ANNOUNCEMENT_FIELDS} columns={C.ANNOUNCEMENT_COLUMNS} testid="announcements" entity="Pengumuman" />
    </div>
  );
}

export function AssignmentsPage() {
  const [a, setA] = useState(null);
  return (
    <div data-testid="admin-assignments-page">
      <PageHeader eyebrow="Tugas" title="Tugas & penilaian" description="Buat tugas, lihat pengumpulan siswa, dan beri nilai." />
      <CrudManager endpoint="/admin/assignments" fields={C.ASSIGNMENT_FIELDS} columns={C.ASSIGNMENT_COLUMNS} testid="assignments" entity="Tugas"
        rowActions={(r) => <Button size="sm" variant="outline" className="mr-1" onClick={() => setA(r)} data-testid={`submissions-open-${r.id}`}>Pengumpulan</Button>} />
      {a && <SubmissionsDialog assignment={a} onClose={() => setA(null)} />}
    </div>
  );
}

export function useIsAdmin() {
  const { user } = useAuth();
  return user?.role === "admin";
}
